export const mobilePaddingTopBottom = 3.5
export const mobilePaddingLeftRight = 1
export const desktopPaddingLeftRight = 15
export const desktopPaddingTopBottom = 5
